import * as actions from './actions';

export const setModal = (modal) => ({
  type: actions.MODAL_SET,
  modal
});


// WEBPACK FOOTER //
// ./src/store/actions/modal.js